import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { getFieldComponent } from "../utils/field-mapper";
import { TextField, CommentField, DropdownField, RadioGroupField, BooleanField, NumberField, FileUploadField, ImagePickerField, RatingField, RankingField, MatrixField, MatrixDropdownField, MatrixDynamicField, MultipleTextField, TagboxField, CheckboxField, PanelField, SignaturePadField, ImageField, HtmlField, ExpressionField, } from "./fields";
export var FIELD_COMPONENTS = {
    text: TextField,
    tel: TextField,
    password: TextField,
    email: TextField,
    url: TextField,
    date: TextField,
    "datetime-local": TextField,
    comment: CommentField,
    dropdown: DropdownField,
    tagbox: TagboxField,
    radiogroup: RadioGroupField,
    checkbox: CheckboxField,
    boolean: BooleanField,
    number: NumberField,
    file: FileUploadField,
    imagepicker: ImagePickerField,
    rating: RatingField,
    ranking: RankingField,
    matrix: MatrixField,
    matrixdropdown: MatrixDropdownField,
    matrixdynamic: MatrixDynamicField,
    multipletext: MultipleTextField,
    panel: PanelField,
    signaturepad: SignaturePadField,
    image: ImageField,
    html: HtmlField,
    expression: ExpressionField,
};
/**
 * Componente genérico que renderiza o campo apropriado baseado no tipo do elemento
 */
var FormField = function (_a) {
    var element = _a.element, errors = _a.errors;
    var fieldType = getFieldComponent(element);
    var FieldComponent = FIELD_COMPONENTS[fieldType] || TextField;
    return _jsx(FieldComponent, { element: element, errors: errors });
};
export default FormField;
